import Subscription from './subscription'

export default class EventHandler {
	_subscriptions = {};
	_events = [];

	constructor(events = []) {
		this._events = events;
	}

	get subscriptions() {
		return this._subscriptions;
	}

	get events() {
		return this._events;
	}

	set events(value) {
		this._events = value;
	}

	subscribe(eventName, listener) {
		this._validateEvent(eventName);
		return this._createSubscription(this, listener, eventName);
	}

	subscribeToAll(listener) {
		return this._createSubscription(this, listener);
	}

	publish(eventName) {
		this._validateEvent(eventName);
		const eventSubscriptions = Object.values(this._subscriptions).filter((subscription) => subscription.eventName == eventName || subscription.all);
		const eventArgs = Array.from(arguments);

		eventSubscriptions.forEach((subscription) => {
			subscription.listener.apply(subscription, eventArgs);
		});
	}

	_createSubscription(...args) {
		const subscription = new Subscription(...args);
		this._subscriptions[subscription.eventId] = subscription;
		return subscription;
	}

	_validateEvent(eventName) {
		if(this._events.length > 0 && this._events.indexOf(eventName) < 0) {
			throw `The event ${eventName} is not supported by this EventHandler`;
		}
	}
}
